export var ContactType = [
    'Services',
    'General',
    'Business',
    'Account',
    'Website',
    'Misc',
    'Donations',
];
